import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VChip,
    {
      staticClass: "my-2",
      class: _vm.isActive ? "pr-1" : undefined,
      attrs: {
        color: _vm.isActive ? "primary" : "bg-primary",
        "text-color": _vm.isActive ? "bg-gray-0" : "primary",
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "text-truncate", style: { maxWidth: `200px` } },
        [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.isActive
        ? _c(
            VBtn,
            {
              staticClass: "ml-1",
              attrs: {
                icon: "",
                text: "",
                light: "",
                small: "",
                color: "bg-gray-0",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$emit("click:close", $event)
                },
              },
            },
            [
              _c(VIcon, { attrs: { size: "18", light: "" } }, [
                _vm._v("\n      ui-icon-close-circle\n    "),
              ]),
            ],
            1
          )
        : _c(VIcon, { attrs: { right: "", size: "18" } }, [
            _vm._v("\n    ui-icon-arrow-down\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }